// export const ip = "http://192.168.40.147:8095/"; // 测试环境地址
export const ip = "http://gl.pangodso.com/web_gl/"; // 域名正式地址
// export const URL = "http://192.168.40.147:8091/"; // 模版图片地址前缀
// export const URL = "https://www.chsnrzy.com/web_file/"; // 模版图片地址前缀
// export const uploadURL = ip + "web/file/front/upload"; // 上传地址
// export const partUploadUrl = ip + "web/file/part"; // 文件分片上传地址
// export const mergeUrl = ip + "web/file/merge"; // 文件分片合成地址
// export const codeURL = ip + "index/loginAdmin/getVerify"; // 登录图形验证码
//富文本框文件上传配置
export const uploadConfig = {
  action: "", // 必填参数 图片上传地址
  methods: "", // 必填参数 图片上传方式
  token: "", // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
  name: "img", // 必填参数 文件的参数名
  size: 500, // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
  accept: "image/png, image/gif, image/jpeg, image/bmp, image/x-icon", // 可选 可上传的图片格式
};
// 工具栏配置
export const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indents
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["clean"], // remove formatting button
  ["link", "image", "video"],
];
